import { Box, Typography, Tooltip } from "@mui/material";
// config
import colors from "../../../config/colors";

const ENGAGEMENT_BUCKETS = [
  {
    label: "Bronze",
    color: colors.primary100,
    value: "<3%",
  },
  {
    label: "Silver",
    color: colors.primary100,
    value: "3-5%",
  },
  {
    label: "Gold",
    color: colors.primary100,
    value: "5-10%",
  },
  {
    label: "Platinum",
    color: colors.primary100,
    value: "10-20%",
  },
  {
    label: "Diamond",
    color: colors.primary100,
    value: ">20%",
  },
];

// Tooltip content for engagement rate buckets
const EngagementTooltipContent = () => (
  <Box sx={{ p: 1 }}>
    <Typography
      variant="subtitle2"
      sx={{ fontWeight: "bold", mb: 1, fontSize: 12 }}
    >
      Engagement Rate Buckets:
    </Typography>
    {ENGAGEMENT_BUCKETS.map((bucket, index) => (
      <Typography key={index} variant="body2" sx={{ fontSize: 11, mb: 0.3 }}>
        • {bucket.label} ({bucket.value})
      </Typography>
    ))}
  </Box>
);

const Engagement = ({ item }) => {
  const engagementRate = item?.overall_engagement_rate_percentage || 0;

  const getEngagementTier = (rate) => {
    if (rate >= 20) return ENGAGEMENT_BUCKETS[4];
    if (rate >= 10) return ENGAGEMENT_BUCKETS[3];
    if (rate >= 5) return ENGAGEMENT_BUCKETS[2];
    if (rate >= 3) return ENGAGEMENT_BUCKETS[1];
    return ENGAGEMENT_BUCKETS[0];
  };

  const tier = getEngagementTier(engagementRate);

  return (
    <Tooltip
      title={<EngagementTooltipContent />}
      arrow
      placement="top"
      componentsProps={{
        tooltip: {
          sx: {
            bgcolor: colors.gray900,
            color: colors.white,
            fontSize: 11,
            maxWidth: 220,
          },
        },
        arrow: {
          sx: {
            color: colors.gray900,
          },
        },
      }}
    >
      <Box
        sx={{
          backgroundColor: tier.color,
          padding: "2px 8px",
          borderRadius: 0.5,
          textAlign: "center",
          minWidth: "fit-content",
          display: "inline-block",
          cursor: "help",
        }}
      >
        <Typography fontSize={10} fontWeight={500} lineHeight="16px">
          {tier.label}
        </Typography>
      </Box>
    </Tooltip>
  );
};

export default Engagement;
